import { render, staticRenderFns } from "./Page033.vue?vue&type=template&id=18dbdd59&scoped=true&"
import script from "./Page033.vue?vue&type=script&lang=js&"
export * from "./Page033.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbdd59",
  null
  
)

export default component.exports